import * as Yup from 'yup';

export default Yup.object().shape({
  invoicePdfUrl: Yup.mixed(),
  invoiceXmlUrl: Yup.mixed(),
  serialNumber: Yup.string()
    .max(30)
    .nullable()
});
